const Blockly = require('blockly');
const dataAccessMethods = require('../../../../dataAccessMethods');
const setupAddCodeProperties = require('../../../../helpers/addCodeProperties');

const TOOLTIP =
    'Filter a given control\'s contents based on the "active" record: the one selected made by a user (often in a Grid or Card View).';

function addBlockSpecificFields(color, blocklyBlock, mdcBlock, line1OfInputs) {
    let workspace = blocklyBlock.workspace;
    let blockId = blocklyBlock.id;

    blocklyBlock.setTooltip(TOOLTIP);
    //set inputs to be arranged vertically.
    //Meaning each (dummy)input starts a new line
    blocklyBlock.setInputsInline(false);
    line1OfInputs
        .appendField('|   Record Namespace:')
        .appendField(new Blockly.FieldDropdown(dataAccessMethods.getNamespaces), 'namespace')
        .appendField('  Record Relation:')
        .appendField(new Blockly.FieldDropdown(() => dataAccessMethods.getRelations(workspace, blockId)), 'relation');
    blocklyBlock
        .appendDummyInput()
        .setAlign(Blockly.ALIGN_RIGHT)
        .appendField('  Optional Relationship Property:')
        .appendField(new Blockly.FieldTextInput(''), 'propertyName');
}

function convertCustomFieldsToCode(code, blocklyBlock) {
    const addCodeProperties = setupAddCodeProperties(code, blocklyBlock);
    addCodeProperties(['namespace', 'relation', 'propertyName']);
    return code;
}

module.exports = { addBlockSpecificFields, convertCustomFieldsToCode };
